import React from 'react'
import { FilePreview } from '@ow/comps'
import {
  useDitto,
  checkIsImage,
  getWatermarkUrl,
  checkFile,
  getType,
} from '@ow/ditto-core'
import { IconMaps } from '@ow/icons'
import { fileTypeImg } from '../../utils/file-constants'

const showMediaType = ['image', 'video', 'audio']
const MediaItem = ({ files, url, item, rowData, index }) => {
  const { addWatermarkToImage } = useDitto()
  const { filename, fileType } = item
  const extension = fileType || checkFile(url)
  const { key } = getType(extension)

  let src = url
  const position = url.indexOf('?Expires=') // 对非表单新建的数据特殊处理
  if (url.indexOf('ow-prod.oss-') > -1 || url.indexOf('ow-prod-cdn') > -1) {
    src = `${
      position === -1 ? url : url.slice(0, position)
    }?x-oss-process=image/resize,h_170,m_lfit`
  }
  const getMedia = () => {
    let media = (
      <div className="flex flex-row items-center w-auto h-full">
        <img
          className="rounded-box"
          src={fileTypeImg[extension] || fileTypeImg[key]}
          style={{
            width: '25px',
            height: '60%',
          }}
          alt=""
        />
        <span
          className="ml-1 overflow-hidden text-ellipsis truncate"
          style={{ maxWidth: '5rem' }}
        >
          {filename}
        </span>
        <span>.{extension}</span>
      </div>
    )
    if (showMediaType.includes(key)) {
      if (key === 'video') {
        media = (
          <div
            className="relative cursor-pointer overflow-hidden"
            style={{ borderRadius: '4px', height: '11rem', width: '11rem' }}
          >
            <div
              className="absolute w-full h-full t-0 l-0"
              style={{
                background: 'rgba(0,0,0,.5)',
                textAlign: 'center',
                lineHeight: '12.5rem',
              }}
            >
              <div className="inline-block">
                <IconMaps width={40} height={40} size={40} type="play" />
              </div>
            </div>
            <img
              src={`${
                url.split('?')[0]
              }?x-oss-process=video/snapshot,t_1,f_jpg,w_1280,h_720,m_fast,ar_auto`}
              alt=""
              className="w-full h-full"
            />
          </div>
        )
      } else {
        media = (
          <img
            src={
              key === 'image' ? src : fileTypeImg[extension] || fileTypeImg[key]
            }
            alt=""
            style={{ height: '11rem', width: '11rem', borderRadius: '4px' }}
          />
        )
      }
    }
    return media
  }
  return (
    <div className="gap-2 flex flex-row items-center w-auto">
      <div
        className="w-auto flex items-center"
        style={{
          fontSize: '0.8125rem',
        }}
        onClick={() => {
          FilePreview.preview(
            files.map((v) => {
              const endPosition = url.indexOf('?Expires=')
              const isImage = checkIsImage(v)
              const link = v.src || v.link
              const originSrc =
                endPosition === -1 ? link : link.slice(0, endPosition)
              if (v.waterMarkInfo) {
                const { originWatermarkUrl, thumbnailWatermarkUrl } =
                  getWatermarkUrl(
                    { originSrc, ...v },
                    addWatermarkToImage,
                    v.waterMarkInfo
                  )
                return {
                  ...v,
                  data: rowData,
                  src: originSrc,
                  srcWatermark: isImage ? thumbnailWatermarkUrl : src, // 冲突了，暂时保留闫俊的
                  originWatermarkUrl,
                }
              }
              return {
                ...v,
                data: rowData,
                src: originSrc,
                srcWatermark: originSrc, // 冲突了，暂时保留闫俊的
                originWatermarkUrl: originSrc,
              }
            }),
            index
          )
        }}
      >
        {getMedia()}
      </div>
    </div>
  )
}

const Media = function ({ value }) {
  if (!value || value.length === 0) {
    return '暂无数据'
  }
  return (
    <>
      {(value || []).map((item, index) => {
        const { src, link } = item || {}
        if (src || link) {
          return (
            <MediaItem
              files={value || []}
              key={index}
              item={item}
              url={src || link}
              index={index}
              isClicked={false}
            />
          )
        }
        return null
      })}
    </>
  )
}
export default Media
